import gsap from 'gsap';
import Swiper from 'swiper/bundle';
import isIPad from './isIPad';

export default () => {
    const block = document.querySelector('.main-slider');

    if (!block) {
        return;
    }

    const header = document.querySelector('.main-header');
    const mainSliderList = document.querySelector('.main-slider__list');
    const mainSliderListNav = document.querySelector('.main-slider__nav-list');
    const autoplay = 6000; //5000
    const autoplayS = autoplay / 1000;
    const slideSpeed = 900;
    const progressBar = document.getElementById('progress');
    const authors = block.querySelectorAll('.author a, .author__line');
    let tl = gsap.timeline({ paused: true });

    const setFullyProgressBar = () => gsap.set(progressBar, { scaleX: 1 });
    const resetFullyProgressBar = () => {

        tl.pause();
        
        gsap.to(progressBar, {
            scaleX: 0,
            duration: slideSpeed / 1000 - 0.1,
            ease: 'power2.out',
            onComplete: ()  => {
                tl.play();
            }
        });
        

    };

    setFullyProgressBar();

    setTimeout(function () {
        removeActive(block)
        // block.classList.remove('active');

        tl.play();
        resetFullyProgressBar();
    }, 3100);

    const mainSliderContentNav = new Swiper(mainSliderListNav, {
        direction: 'vertical',
        autoHeight: true,
        speed: slideSpeed,
        height: 145,
        spaceBetween: 50,
        autoplay: false,
        allowSlidePrev: false,
        allowSlideNext: false,
        watchSlidesProgress: true,
        
    });

    const mainSliderContent = new Swiper(mainSliderList, {
        direction: 'vertical',
        autoplay: false,
        mousewheel: true,
        speed: slideSpeed,
        controller: {
        control: [mainSliderContentNav],
        },
        updateOnWindowResize: true,
    });

    mainSliderContent.on('slideChange', function () {
        if (!block.classList.contains('active')) {
            tl.pause();

            gsap.to(progressBar, {
                scaleX: 0,
                duration: slideSpeed / 1000 - 0.1,
                ease: 'power2.out',
                onComplete: () => {
                tl.play(0);
                },
            });
        }
    });

    tl.to(progressBar, {
        scaleX: 1,
        duration: autoplayS,
        ease: 'none',
    });

    tl.eventCallback('onComplete', () => {
        // console.log('progress complete');
        mainSliderContent.slideNext() || mainSliderContent.slideTo(0);
        gsap.to(progressBar, {
            scaleX: 0,
            duration: slideSpeed / 1000 - 0.1,
            ease: 'power2.out',
            onComplete: () => {
                tl.play(0);
            },
        });
    });

    block.addEventListener('click', function (e) {
        e.preventDefault();

        let header = document.querySelector('header');
        // const logo = document.querySelector('.logo-block');

        if (this.classList.contains('active')) {
            removeActive(this)
            // this.classList.remove('active');
            header.classList.remove('stop-slider');
            gsap.to(progressBar, {
                scaleX: 0,
                duration: slideSpeed / 1000 - 0.1,
                ease: 'power2.out',
                onComplete: () => {
                tl.play(0);
                },
            });
        } else {
            // this.classList.add('active');
            addActive(this)
            header.classList.add('stop-slider');
            tl.pause();

            gsap.to(progressBar, {
                scaleX: 1,
                duration: slideSpeed / 1000 - 0.1,
                ease: 'power2.out',
            });
        }
    });

    // Reduce header on screens with small height
    checkViewportHieght();

    window.addEventListener('resize', checkViewportHieght);
    window.addEventListener('orientationchange', () => {
        setTimeout(() => {
            mainSliderContent.update();
        }, 200);
    });

    function checkViewportHieght() {
        const viewportHeight = 760;

        if (window.innerHeight <= viewportHeight && !isIPad()) {
            document.body.classList.add('small-height');
        } else {
            document.body.classList.remove('small-height');
        }

        mainSliderContent.update();
    }
    function addActive(block){
        block.classList.add('active');
        authors.forEach(item => item.style.color = '#FFF')
    }
    function removeActive(block){
        block.classList.remove('active');
        authors.forEach(item => item.style.color = '#000')
    }
   
};
